import React, { useState, useEffect } from "react";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Education from "./components/Education";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import { IoChatbubblesOutline } from "react-icons/io5";

function App() {
  // Theme state: dark mode default, persisted in localStorage
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "dark";
  });

  const [showChat, setShowChat] = useState(false);

  // Optional AI chat feature flag: disabled by default per requirements
  const isChatEnabled =
    process.env.REACT_APP_ENABLE_CHAT === "true" ||
    process.env.VITE_ENABLE_CHAT === "true";

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  // Scroll reveal observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );

    const revealSections = document.querySelectorAll(".reveal-on-scroll");
    revealSections.forEach((sec) => observer.observe(sec));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="App" data-theme={theme}>
      {/* Sticky Navigation */}
      <Navbar theme={theme} toggleTheme={toggleTheme} />

      {/* Main Sections */}
      <main id="main-content">
        <Hero />
        <div className="reveal-on-scroll"><About /></div>
        <div className="reveal-on-scroll"><Experience /></div>
        <div className="reveal-on-scroll"><Projects /></div>
        <div className="reveal-on-scroll"><Skills /></div>
        <div className="reveal-on-scroll"><Education /></div>
        <div className="reveal-on-scroll"><Contact /></div>
      </main>

      {/* Footer */}
      <Footer />

      {/* Optional Chat feature (Off by default, enabled via REACT_APP_ENABLE_CHAT=true) */}
      {isChatEnabled && (
        <>
          <button
            className={`chat-fab ${showChat ? "hidden" : "visible"}`}
            onClick={() => setShowChat(true)}
            aria-label="Open AI assistant"
            title="Ask my avatar"
          >
            <IoChatbubblesOutline size={26} />
          </button>

          {showChat && <Chatbot onClose={() => setShowChat(false)} />}
        </>
      )}
    </div>
  );
}

export default App;
